import React, { useState } from 'react';
import './LoginPage.css';
import Logo from '../../Images/logo.png';
import { Button, Input, PasswordInput } from '../../Components/ui';
import { MAIN_URL } from '../../constants';
import axios from "axios";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Login = ({ setToken, setRole }) => {
    const [loginNumber, setLoginNumber] = useState("");
    const [loginPassword, setLoginPassword] = useState("");
    const navigate = useNavigate();

    const LoginFunc = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(`${MAIN_URL}/staff/login`, {
                phone_number: loginNumber,
                password: loginPassword,
            });
            const tokenItem = response.data.access_token;
            const userRole = response.data.role;

            localStorage.setItem("admin_token", tokenItem);
            localStorage.setItem("role", userRole);
            localStorage.setItem("refresh_token", response.data.refresh_token);

            setToken(tokenItem);
            setRole(userRole);

            toast.success("Successful login !!!");
            navigate("/");

        } catch (error) {
            if (error.response) {
                toast.error("Login failed! Check credentials.");
                console.error("Validation Error:", error.response.data);
            } else {
                toast.error("Network error. Try again.");
                console.error("Request Error:", error.message);
            }
        }
    };

    return (
        <div className='ui-login'>
            {/* Brend paneli (faqat keng ekranda) — bezaklar faqat CSS */}
            <div className="ui-login__brand" aria-hidden="true">
                <span className="ui-login__orb ui-login__orb--one" />
                <span className="ui-login__orb ui-login__orb--two" />
                <span className="ui-login__grid" />
                <div className="ui-login__brand-content">
                    <img src={Logo} alt="" className="ui-login__brand-logo" />
                    <h1 className="ui-login__brand-title">IIFA boshqaruv paneli</h1>
                    <p className="ui-login__brand-text">
                        Kurslar, studentlar va sertifikatlarni bir joyda boshqaring
                    </p>
                </div>
            </div>

            <div className="ui-login__main">
                <div className="ui-login__panel">
                    <img src={Logo} alt="IIFA" className="ui-login__logo" />
                    <form onSubmit={LoginFunc} autoCapitalize='off' className='ui-login__form'>
                        <div className="ui-login__head">
                            <h2 className="ui-login__title">Tizimga kirish</h2>
                            <p className="ui-login__subtitle">Telefon raqamingiz va parolingizni kiriting</p>
                        </div>
                        <Input
                            label="Telefon raqam"
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^[\d+]*$/.test(value)) {
                                    setLoginNumber(value);
                                }
                            }}
                            value={loginNumber}
                            required
                            placeholder='+998901234567'
                            type="text"
                            inputMode="tel"
                            autoComplete="username"
                        />
                        <PasswordInput
                            label="Parol"
                            onChange={(e) => setLoginPassword(e.target.value)}
                            value={loginPassword}
                            required
                            placeholder='Parolingiz'
                            autoComplete="current-password"
                        />
                        <Button type="submit" size="lg" fullWidth>
                            Kirish
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;